export default __webpack_public_path__ + "static/media/outstanding-payments.2d40a7a1.svg";